var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddColumnAfter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H8C8.55 2 9.02083 2.19583 9.4125 2.5875C9.80417 2.97917 10 3.45 10 4V18C10 18.55 9.80417 19.0208 9.4125 19.4125C9.02083 19.8042 8.55 20 8 20H4ZM8 4H4V18H8V4Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 4H18V14H20V4C20 3.45 19.8042 2.97917 19.4125 2.5875C19.0208 2.19583 18.55 2 18 2H14C13.45 2 12.9792 2.19583 12.5875 2.5875C12.1958 2.97917 12 3.45 12 4V18C12 18.55 12.1958 19.0208 12.5875 19.4125C12.9792 19.8042 13.45 20 14 20V4H14.1Z",
    fill: "#3DDB69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20V22H20V20H22V18H20V16H18V18H16V20H18Z",
    fill: "#3DDB69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddColumnAfter);
export default __webpack_public_path__ + "static/media/add_column_after.41e6b9b72af6a7c33c15aa130fbc5b3c.svg";
export { ForwardRef as ReactComponent };